<template>
    <div class="white-dot"></div>
    <div v-b-tooltip.hover.top="tooltipContent" class="white-box-pi">
        <div>
            <p class="id-txt-pi">{{ StoreId }}</p>
            <p>{{ truncatedBoxText }}</p>
        </div>
        <div v-if="Badge">
            <p class="icon-box-green-pi">{{ count }}</p>
        </div>
    </div>
    <div class="white-dot"></div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
export default defineComponent({
    props: {
        boxtext:
        {
            type: String,
            default: ''
        },
        count:
        {
            type: String,
            default: '0'
        },
        Badge:
        {
            type: Boolean,
            default: false
        },
        StoreId:
        {
            type: String,
            default: ''
        },
        tooltipContent: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const truncatedBoxText = computed(() => {
            if (props.boxtext.length <= 15) {
                return props.boxtext;
            } else {
                return props.boxtext.slice(0, 15) + '...';
            }
        });
        return {
            truncatedBoxText,
        };
    },
});
</script>


<style lang="scss" scoped>
.white-box-pi {
    background-color: white;
    padding: 10px 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    width: 90px;
    cursor: pointer;
}

.white-dot {
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: white;
    border-radius: 50%;
}

.icon-box-green-pi {
    background-color: #61C554;
    color: white !important;
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 20px;
    height: 20px;
    margin-left: 5px;
}

.id-txt-pi {
    color: #999999 !important;
    font-size: 10px !important;
    text-align: left;
}

@media only screen and (max-width: 1180px) {
    .white-box-pi {
        width: 65px;
    }
}

@media only screen and (max-width: 992px) and (min-width: 768px) {
    .white-box-pi {
        width: 72px;
    }
}
</style>